/* Leanne's Bakery — limiet van 1 doos per bestelling, ook in de winkelwagen.
   Plaats dit bestand in assets/ en laad het in theme.liquid (zie instructies).
   Werkt op de winkelwagenpagina én in de winkelwagen-lade van Dawn. */
(function () {
  "use strict";

  // Pas hier aan welk product beperkt wordt en wat het maximum is.
  var HANDLE = "koek-per-post";     // de handle van het product (zie de URL: /products/<handle>)
  var MAX = 1;                      // maximaal aantal per bestelling

  var busy = false;

  function getCart() {
    return fetch("/cart.js", { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.json(); });
  }

  // Zet alle regels van dit product terug naar MAX en tel het totaal.
  function clamp() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return getCart().then(function (cart) {
      var mine = [];
      (cart.items || []).forEach(function (it, i) {
        if (it.handle === HANDLE) mine.push({ line: i + 1, qty: it.quantity, key: it.key });
      });
      if (!mine.length) { busy = false; return false; }

      // Totaal over alle regels van dit product (verschillende samenstellingen = losse regels)
      var total = mine.reduce(function (s, m) { return s + m.qty; }, 0);
      if (total <= MAX) { busy = false; return false; }

      // Houd de eerste regel op MAX, verwijder de rest.
      var updates = {};
      mine.forEach(function (m, idx) { updates[m.key] = idx === 0 ? MAX : 0; });

      return fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        busy = false;
        notify();
        return true;
      }).catch(function () { busy = false; return false; });
    }).catch(function () { busy = false; return false; });
  }

  function notify() {
    var msg = "Je kunt maximaal 1 doos koekjes per keer bestellen.";
    var el = document.querySelector("[data-leanne-cart-note]");
    if (!el) {
      el = document.createElement("div");
      el.setAttribute("data-leanne-cart-note", "");
      el.setAttribute("role", "status");
      el.textContent = msg;
      var host = document.querySelector("cart-items, .cart__items, #main-cart-items, cart-drawer-items");
      if (host && host.parentNode) host.parentNode.insertBefore(el, host);
      else document.body.appendChild(el);
    }
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 6000);
  }

  // Verberg de plus-knop en het aantalveld voor dit product: er kan er maar één in.
  function lockRows() {
    var rows = document.querySelectorAll(
      '.cart-item, .cart__row, tr[id^="CartItem-"], cart-drawer-item, .cart-drawer__item'
    );
    Array.prototype.forEach.call(rows, function (row) {
      var link = row.querySelector('a[href*="/products/"]');
      if (!link || link.getAttribute("href").indexOf("/products/" + HANDLE) === -1) return;
      row.setAttribute("data-leanne-locked", "");
      var plus = row.querySelector('[name="plus"], .quantity__button[name="plus"]');
      if (plus) { plus.disabled = true; plus.setAttribute("aria-hidden", "true"); }
      var input = row.querySelector('.quantity__input, input[name="updates[]"]');
      if (input) { input.readOnly = true; input.max = String(MAX); }
    });
  }

  function run() { clamp().then(function (changed) { lockRows(); if (changed) refresh(); }); }

  // Na een correctie de winkelwagen opnieuw laten tekenen.
  function refresh() {
    if (document.querySelector("cart-drawer, cart-items, #main-cart-items")) {
      window.location.reload();
    }
  }

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("pageshow", run);

  // Dawn vervangt de winkelwagen-HTML na elke wijziging: opnieuw vergrendelen.
  var obs = new MutationObserver(function () { lockRows(); });
  document.addEventListener("DOMContentLoaded", function () {
    var host = document.querySelector("cart-items, #main-cart-items, cart-drawer");
    if (host) obs.observe(host, { childList: true, subtree: true });
  });

  // Ook checken zodra er iets aan de winkelwagen verandert.
  document.addEventListener("cart:refresh", run);
  document.addEventListener("cart:updated", run);
})();